import { RedoCheckbox } from "../../../arbiter-components/checkbox/redo-checkbox";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";

export interface CombineDiscountWith {
  orderDiscounts: boolean;
  productDiscounts: boolean;
  shippingDiscount: boolean;
}

export function CombineDiscountWithField({
  value,
  setValue,
  showProductDiscounts,
  showShippingDiscount,
}: {
  value: CombineDiscountWith;
  setValue: (value: CombineDiscountWith) => void;
  showProductDiscounts: boolean;
  showShippingDiscount: boolean;
}) {
  return (
    <LabeledInput
      label={
        <Text fontWeight="medium" textColor="secondary">
          Combine discount with
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex dir="column" gap="md">
        {showProductDiscounts && (
          <RedoCheckbox
            label="Product discounts"
            setValue={() => {
              setValue({ ...value, productDiscounts: !value.productDiscounts });
            }}
            size="xs"
            value={value.productDiscounts}
          />
        )}
        <RedoCheckbox
          label="Order discounts"
          setValue={() => {
            setValue({ ...value, orderDiscounts: !value.orderDiscounts });
          }}
          size="xs"
          value={value.orderDiscounts}
        />
        {showShippingDiscount && (
          <RedoCheckbox
            label="Shipping discounts"
            setValue={() => {
              setValue({ ...value, shippingDiscount: !value.shippingDiscount });
            }}
            size="xs"
            value={value.shippingDiscount}
          />
        )}
      </Flex>
    </LabeledInput>
  );
}
